<template>
  <div class="staffRecord">
    <!-- <div class="menuCont">
        <el-scrollbar style="height:100%">
            <el-menu
                @open="handleOpen"
                @close="handleClose"
                class="staffMenu"
                background-color="#ffffff"
                unique-opened="true"
                :default-active="defaultActive"
                @select="handleSelect"
            >
                <template v-for="item in menuList">
                    <el-menu-item
                        v-if="!item.child"
                        :key="item.id"
                        :index="item.id"
                    >
                        <i :class="['iconfont',item.icon]"></i>
                        <span slot="title">{{ item.name }}</span>
                        <span slot="title" class="num">
                            {{
                                item.user_num !== 0 ? item.user_num : ""
                            }}</span
                        >
                    </el-menu-item>
                    <el-submenu v-else :key="item.id" :index="item.id">
                        <template slot="title">
                            <i :class="['iconfont','icon-yuan']"></i>
                            <span>{{ item.name }}</span>
                            <span slot="title">{{
                                item.user_num !== 0 ? item.user_num : ""
                            }}</span>
                        </template>
                        <template v-for="second in item.child">
                            <el-menu-item
                                ref
                                v-if="!second.child"
                                :key="second.id"
                                :index="second.id"
                                style="padding-left:60px;"
                            >
                                <span slot="title">{{ second.name }}</span>
                                <span slot="title" class="num">{{
                                    item.user_num !== 0 ? item.user_num : ""
                                }}</span>
                            </el-menu-item>
                            <el-submenu
                                v-else
                                :key="second.id"
                                :index="second.url"
                            >
                                <template slot="title">{{
                                    second.name
                                }}</template>
                                <el-menu-item
                                    :index="third.id"
                                    v-for="third in second.child"
                                    :key="third.id"
                                    >{{ third.name }}</el-menu-item
                                >
                            </el-submenu>
                        </template>
                    </el-submenu>
                </template>
            </el-menu>
        </el-scrollbar>
    </div> -->
    <div class="tableCont">
      <el-drawer
          title="高级搜索"
          :visible.sync="drawerVisible"
          size="320px"
          class="drawerCont"
          ref="drawer"
          :wrapperClosable="false"
      >
        <el-scrollbar class="scrollbar">
          <el-form
              :model="searchForm"
              label-width="120"
              class="drawerForm"
          >
            <el-form-item label="员工姓名" size="small">
              <el-input
                  clearable
                  placeholder="请输入员工姓名"
                  size="small"
                  v-model="searchForm.name"
                  @keydown.enter.native="userGet"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="联系电话" size="small">
              <el-input
                  clearable
                  placeholder="请输入联系电话"
                  size="small"
                  v-model.number="searchForm.phone"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  @keydown.enter.native="userGet"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="所在部门" size="small">
              <el-cascader
                  clearable
                  :options="departList"
                  :props="props"
                  v-model="searchForm.depart_list"
                  style="width: 100%"
                  placeholder="请选择所在部门"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="状态" size="small">
              <el-select
                  v-model="searchForm.status"
                  clearable
                  size="small"
                  placeholder="请选择状态"
                  @change="userGet"
              >
                <el-option
                    v-for="item in statusList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="text-align: right">
              <el-button
                  type="danger"
                  icon="el-icon-refresh-right"
                  size="small"
                  @click="clean"
              >
                重置条件
              </el-button>
            </el-form-item>
          </el-form>
        </el-scrollbar>
        <div class="drawer-footer">
          <el-button
              style="width: 100%"
              type="primary"
              icon="el-icon-search"
              size="small"
              @click="userGet(1)"
          >
            查询
          </el-button>
        </div>
      </el-drawer>
      <div class="searchCont">
        <div class="searchContLeft">
          <el-form
              :inline="true"
              :model="searchForm"
              label-width="120"
          >
            <el-form-item label="员工姓名" size="mini">
              <el-input
                  clearable
                  placeholder="请输入员工姓名"
                  size="mini"
                  v-model="searchForm.name"
                  @keydown.enter.native="userGet"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="联系电话" size="mini">
              <el-input
                  clearable
                  placeholder="请输入联系电话"
                  size="mini"
                  v-model.number="searchForm.phone"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  @keydown.enter.native="userGet"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="所在部门" size="mini">
              <el-cascader
                  clearable
                  :options="departList"
                  :props="props"
                  v-model="searchForm.depart_list"
                  style="width: 100%"
                  placeholder="请选择所在部门"
                  @change="userGet"
              >
              </el-cascader>
            </el-form-item>
          </el-form>
          <el-button
              icon="el-icon-search"
              size="mini"
              type="primary"
              style="margin-right: 10px"
              @click="userGet(1)"
          ></el-button>
          <div v-if="this.menuAuth">
            <template v-for="item in menuAuth.slice(0, 2)">
              <el-button
                  type="primary"
                  :key="item.id"
                  :icon="item.icon"
                  size="mini"
                  @click="authFunc(item.funcName)"
              >
                {{ item.name }}
              </el-button>
            </template>
            <el-dropdown
                v-if="menuAuth.length > 2"
                @command="authFunc"
                style="margin-left: 10px"
            >
              <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-arrow-down"
              >
                更多操作
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                    :key="item.id"
                    v-for="item in menuAuth.slice(2)"
                    :command="item.funcName"
                    style="font-size: 12px"
                >
                  <i :class="item.icon"></i>
                  {{ item.name }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div v-else></div>
        </div>
        <!-- 高级搜索 -->
        <advancedSearch :drawerVisible.sync="drawerVisible"
        >高级搜索</advancedSearch
        >
      </div>
      <div class="table" :style="{ height: screen }">
        <el-table
            :data="tableData"
            ref="tableData"
            highlight-current-row
            height="100%"
            @selection-change="handleSelectionChange"
            @sort-change="sortChange"
        >
          <el-table-column
              type="selection"
              align="left"
              :fixed="checkFixed"
          >
          </el-table-column>
          <el-table-column
              label="工号"
              property="job_no"
              align="left"
          >
          </el-table-column>
          <el-table-column
              label="员工姓名"
              property="name"
              align="left"
          >
            <template slot-scope="scope">
              <div class="nameCont">
                <div class="headImg" >
                  <el-avatar v-if="scope.row.avatar!=''"
                      size="small"
                      :src="scope.row.avatar"
                  ></el-avatar>
                  <span v-else>
                    <el-avatar
                        size="small"
                        :src="'https://uc-api.loratech.cn/dingtalk/2/user/'+encodeURIComponent(scope.row.name)+'/avatar/50'"
                  ></el-avatar></span>

                </div>
                <div class="memberName">
                  {{ scope.row.name }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="联系电话"
              property="phone"
              width="120"
              align="left"
          ></el-table-column>
          <el-table-column
              label="性别"
              property="sex_cn"
              align="left"
              width="60"
          ></el-table-column>

          <el-table-column
              label="入职日期"
              property="entry_date"
              align="left"
              width="120"
              :default-sort="{ prop: 'orderby_entry', order: null }"
              sortable="custom"
          ></el-table-column>
          <el-table-column
              label="所属部门"
              property="full_depart_name"
              align="left"
              width="200"
          >
            <template slot-scope="scoped">
              <el-tooltip
                  effect="dark"
                  :content="scoped.row.full_depart_name"
                  placement="top"
                  v-if="scoped.row.full_depart_name"
              >
                                <span class="cursor_pointer">{{
                                    scoped.row.depart_name
                                  }}</span>
              </el-tooltip>
              <span class="cursor_pointer" v-else>{{
                  scoped.row.depart_name
                }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="职位"
              width="120"
              property="role_name"
              align="left"
          ></el-table-column>
          <el-table-column label="是否已婚" align="left">
            <template slot-scope="scope">
              {{ scope.row.marriage == 0 ? "未婚" : "已婚" }}
            </template>
          </el-table-column>
          <el-table-column
              label="学历"
              align="left"
              prop="education"
          >
          </el-table-column>

          <el-table-column
              label="籍贯"
              align="left"
              prop="hometown"
          >
          </el-table-column>
          <!-- <el-table-column label="生日"
                 property="identity"
                 align="center">
  <template slot-scope="scope">
    {{scope.row.identity.slice(10,14)}}
  </template>
</el-table-column> -->
<!--          <el-table-column label="当前状态" align="center">
            <template slot-scope="scope">
              &lt;!&ndash; <el-tag
                  size="mini"
                  :type="
                      scope.row.status == 1 ? 'success' : 'danger'
                  "
              >
                  {{ scope.row.status_cn }}
              </el-tag> &ndash;&gt;
              <p class="oa-tag oa-tag-success">
                <i class="iconfont icon-zaizhi"></i>
                <span>{{ scope.row.status_cn }}</span>
              </p>
            </template>
          </el-table-column>-->

          <el-table-column
              label="在职天数"
              property="work_age"
              width="120"
              align="left"
              :default-sort="{ prop: 'orderby_workday', order: null }"
              sortable="custom"
          >
          </el-table-column>
          <el-table-column
              label="操作"
              header-align="left"
              width="200"
              :fixed="operationFixed"
          >
            <template slot-scope="scope">
              <div class="operation-btns">
                                <span
                                    v-for="item in scope.row.authority"
                                    :key="item.id"
                                >
                                    <el-button
                                        v-if="
                                            item.name != '删除' &&
                                            item.name != '重置密码'
                                        "
                                        type="text"
                                        size="small"
                                        @click="rowDo(scope.row, item)"
                                    >{{ item.name }}</el-button
                                    >
                                  <!-- <delPopConfirm
                                      v-else-if="item.name == '删除'"
                                      @delConfirm="del(scope.row, item)"
                                  ></delPopConfirm> -->
                                    <popConfirm
                                        v-else-if="item.status_flag == 4"
                                        :title="item.name"
                                        :buttonText="item.name"
                                        @confirm="rowDo(scope.row, item)"
                                    >
                                    </popConfirm>
                                    <el-popover
                                        v-else-if="item.name == '重置密码'"
                                        placement="right"
                                        width="400"
                                        trigger="click"
                                        :ref="`popoverPwd-${scope.$index}`"
                                    >
                                        <p class="modify_pwd_title">修改密码</p>
                                        <el-form
                                            :model="passwordForm"
                                            ref="passwordForm"
                                            label-width="100px"
                                            class="formCont"
                                        >
                                            <el-form-item
                                                prop="password"
                                                :rules="[
                                                    {
                                                        required: true,
                                                        message: '请输入新密码',
                                                    },
                                                ]"
                                                label="新密码"
                                                style="margin-bottom: 10px"
                                            >
                                                <el-input
                                                    placeholder="请输入新密码"
                                                    maxlength="30"
                                                    size="mini"
                                                    show-password
                                                    v-model="
                                                        passwordForm.password
                                                    "
                                                >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item
                                                prop="passwordAgain"
                                                label="确认密码"
                                                :rules="[
                                                    {
                                                        required: true,
                                                        message:
                                                            '请再次输入新密码',
                                                    },
                                                ]"
                                            >
                                                <el-input
                                                    placeholder="请输入再次新密码"
                                                    maxlength="30"
                                                    size="mini"
                                                    show-password
                                                    v-model="
                                                        passwordForm.passwordAgain
                                                    "
                                                >
                                                </el-input>
                                            </el-form-item>
                                            <div style="text-align: right">
                                                <el-button
                                                    @click="
                                                        closePwdDialog(
                                                            scope.$index
                                                        )
                                                    "
                                                    size="mini"
                                                >取 消</el-button
                                                >
                                                <el-button
                                                    type="primary"
                                                    @click="
                                                        changeUserPwd(
                                                            scope.$index,
                                                            scope.row
                                                        ).then((_) => {
                                                            item.visible = false;
                                                        })
                                                    "
                                                    size="mini"
                                                >确 定</el-button
                                                >
                                            </div>
                                        </el-form>
                                        <el-button
                                            slot="reference"
                                            type="text"
                                            size="small"
                                        >{{ item.name }}</el-button
                                        >
                                    </el-popover>
                                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <pagination
          :paginationData="paginationData"
          @paginationChange="paginationChange"
      ></pagination>
    </div>

    <StaffRecordDetail
        :detailVisible.sync="detailVisible"
        :tableItem="tableItem"
    ></StaffRecordDetail>
    <StaffRecordAdd :addVisible.sync="addVisible"
                    :educationList="educationList"
    ></StaffRecordAdd>
    <StaffRecordEdit
        :editVisible.sync="editVisible"
        :educationList="educationList"
        :tableItem="tableItem"
    ></StaffRecordEdit>
    <!-- <el-dialog
        class="password"
        :visible.sync="passwordVisible"
        :close-on-click-modal="false"
        @closed="closePwdDialog"
        width="600px"
        title="修改密码"
    >
        <el-form
            :model="passwordForm"
            ref="passwordForm"
            label-width="100px"
            class="formCont"
        >
            <el-form-item
                prop="password"
                :rules="[{ required: true, message: '请输入新密码' }]"
                label="新密码"
            >
                <el-input
                    placeholder="请输入新密码"
                    maxlength="30"
                    size="mini"
                    v-model="passwordForm.password"
                >
                </el-input>
            </el-form-item>
            <el-form-item
                prop="passwordAgain"
                label="确认密码"
                :rules="[{ required: true, message: '请再次输入新密码' }]"
            >
                <el-input
                    placeholder="请输入再次新密码"
                    maxlength="30"
                    size="mini"
                    v-model="passwordForm.passwordAgain"
                >
                </el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="passwordVisible = false" size="mini"
                >取 消</el-button
            >
            <el-button type="primary" @click="changeUserPwd" size="mini"
                >确 定</el-button
            >
        </span>
    </el-dialog> -->
    <el-dialog
        class="setRole"
        :visible.sync="setRoleVisible"
        :close-on-click-modal="false"
        @closed="closeSetRoleDialog"
        width="400px"
        title="设置角色"
    >
      <el-form :inline="true">
        <el-form-item label="绑定角色">
          <el-select
              v-model="roleId"
              clearable
              placeholder="请选择角色类型"
              size="small"
          >
            <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="setRoleSave" size="mini"
                >保 存</el-button
                >
            </span>
    </el-dialog>
    <importPublic
        :importVisible.sync="importVisible"
        :parentFuncName="'userGet'"
        :methodName="'userImport'"
        :temSrc="'/v1/user/download-tpl'"
        :title="'在职员工导入'"
    ></importPublic>
  </div>
</template>
<script>
import * as api from "@/http/api.js";
import * as oaApi from "@/http/oaApi.js";
import { tableMixin } from "@/utils/tableMixins.js";
import StaffRecordDetail from "./staffRecord/detail";
import StaffRecordAdd from "./staffRecord/add";
import StaffRecordEdit from "./staffRecord/edit";
import pagination from "@/comon/components/pagination";
import importPublic from "@/comon/components/importPublic";
import delPopConfirm from "@/comon/components/delPopConfirm";
import popConfirm from "@/comon/components/popConfirm";
import advancedSearch from "@/comon/components/advancedSearch";
import {educationSelect} from "@/http/oaApi.js";

export default {
  mixins: [tableMixin],
  data() {
    return {
      menuList: [],
      defaultActive: 0,
      searchForm: {
        name: "",
        phone: "",
        status: 1,
      },
      menuId: 0,
      tableData: [],
      paginationData: {
        page: 1,
        "per-page": 20,
        total: "",
      },

      tableItem: [],
      detailVisible: false,
      addVisible: false,
      passwordVisible: false,
      editVisible: false,
      passwordForm: {
        password: "",
        passwordAgain: "",
      },
      rowId: "",
      bulkVisible: false,
      errArray: [],
      success_num: 0,
      failure_num: 0,

      statusList: [
        { id: 1, name: "在职" },
        { id: 99, name: "已删除" },
      ],

      selectionUserIdList: [],
      setRoleVisible: false,
      typeList: [],
      roleId: 4,
      searchFormH: "",
      orderby_entry: null,
      orderby_workday: null,
      importVisible: false,
      drawerVisible: false,

      props: {
        // 配置项（必选）
        value: "id",
        label: "name",
        children: "child",
        checkStrictly: true,
      },
      // 选项列表（必选）
      departList: [],
      educationList: [],
    };
  },
  mounted() {
    this.educationSelect();
  },
  methods: {
    clean() {
      this.searchForm = {
        name: "",
        phone: "",
        status: 1,
      };
      if (this.$refs.selectBtn) {
        this.$refs.selectBtn.clearHandle();
      }
      //   this.menuId = "";
    },
    detail(row) {
      this.tableItem = row;
      this.detailVisible = true;
    },
    add() {
      this.addVisible = true;
    },
    del(row, item) {
      oaApi.user({}, "delete", row.id).then((res) => {
        if (res) {
          if (res.code == 200) {
            this.$message.success(`${item.name}成功`);
            this.userGet();
          }
        }
      });
    },
    onPreview(file) {
      window.open(file);
    },
    /**
     *  获取组织架构信息
     */
    depart() {
      api.depart({}, "get").then((res) => {
        if (res) {
          this.departList = res.data;
        }
      });
    },
    /**
     * 获取图片头像
     */
    getAvatar(userName){
      api.userAvatar(userName).then((res) => {
        if (res) {
          alert(res);
        }
      });
    },
    /**
     * 菜单选择
     */
    handleSelect(val) {
      this.searchForm = {
        name: "",
        phone: "",
        status: 1,
      };
      this.page = 1;
      this.perPage = 20;
      this.menuId = val;
      this.userGet();
    },
    /**
     * 获取员工列表
     */
    userGet(page) {
      page ? (this.paginationData.page = 1) : "";
      oaApi
          .user(
              {
                depart_id: this.menuId,
                ...this.searchForm,
                ...this.paginationData,
                orderby_entry: this.orderby_entry,
                orderby_workday: this.orderby_workday,
                menu_id: this.menu_id
              },
              "get"
          )
          .then((res) => {
            if (res) {
              this.tableData = res.data;
              this.paginationData.total = res.total;
              this.$refs.tableData.bodyWrapper.scrollTop = 0;
              this.drawerVisible = false;
            }
          });
    },
    /**
     * 根据table数据循环事件分发
     */
    rowDo(row, item) {
      if (item.name == "查看") {
        this.detail(row);
      } else if (item.name == "编辑") {
        this.edit(row);
      } else if (item.name == "删除") {
        /* this.$confirm(`确定${item.name}?`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        })
            .then(() => */
        oaApi.user({}, "delete", row.id).then((res) => {
          if (res) {
            if (res.code == 200) {
              this.$message.success(`${item.name}成功`);
              this.userGet();
            }
          }
        });
        /* )
            .catch(() => {
                this.$message.info("已取消操作");
            }); */
      }
    },
    /**
     * table内编辑
     */
    edit(row) {
      this.tableItem = row;
      this.editVisible = true;
    },
    /**
     * 重置密码
     */
    resetPwd(row) {
      this.rowId = row.id;
      this.passwordVisible = true;
    },
    /**
     * 修改密码弹窗 关闭事件
     */
    closePwdDialog(index) {
      this.$refs[`popoverPwd-${index}`][0].doClose();
      this.passwordForm = {
        password: "",
        passwordAgain: "",
      };
      this.$refs["passwordForm"][index].resetFields();
      this.$refs["passwordForm"][index].clearValidate();
    },
    /**
     * 修改密码提交
     */
    changeUserPwd(index, row) {
      return new Promise((resolve, reject) => {
        this.rowId = row.id;
        this.$refs["passwordForm"][index].validate((valid) => {
          if (valid) {
            if (
                this.passwordForm.password ==
                this.passwordForm.passwordAgain
            ) {
              oaApi
                  .changeUserPwd(
                      {
                        password: this.passwordForm.password,
                        user_id: this.rowId,
                      },
                      "post"
                  )
                  .then((res) => {
                    //this.passwordVisible = false;
                    if (res.code == 200) {
                      this.closePwdDialog(index);
                      this.$message.success("修改成功");
                      resolve();
                    }
                  });
            } else {
              this.$message.error("两次输入的密码不同");
            }
          }
        });
      });
    },
    bulkImport() {
      this.importVisible = true;
    },
    // 关闭批量导入员工
    closeBulkDialog() {
      this.errArray = [];
      this.success_num = 0;
      this.failure_num = 0;
      this.userGet();
    },
    authFunc(funcName) {
      this[funcName]();
    },
    userExport() {
      oaApi
          .userExport(
              {
                depart_id: this.menuId,
                ...this.searchForm,
                selectList: this.selectionUserIdList,
              },
              "get"
          )
          .then((res) => {
            if (res) {
              window.open(res.data.url);
            }
          });
    },
    setRole() {
      this.getRoleList();
      if (this.selectionUserIdList.length) {
        this.setRoleVisible = true;
      } else {
        this.$message.error("请选择员工后操作");
      }
    },
    handleSelectionChange(val) {
      this.selectionUserIdList = [];
      for (let i in val) {
        this.selectionUserIdList.push(val[i].id);
      }
    },
    closeSetRoleDialog() {
      this.roleId = 4;
    },
    setRoleSave() {
      oaApi
          .userSetRole(
              {
                userId: this.selectionUserIdList,
                roleId: this.roleId,
              },
              "post"
          )
          .then((res) => {
            if (res) {
              if (res.code == 200) {
                this.$message.success("设置成功");
                this.userGet();
              }
              this.setRoleVisible = false;
            }
          });
    },
    getRoleList() {
      oaApi.role({}, "get").then((res) => {
        if (res) {
          this.typeList = res.data;
        }
      });
    },
    sortChange(column) {
      this.orderby_entry = null;
      this.orderby_workday = null;
      if (column.prop == "entry_date") {
        if (column.order == "descending") {
          this.orderby_entry = "desc";
        } else if (column.order == "ascending") {
          this.orderby_entry = "asc";
        }
      }
      if (column.prop == "work_age") {
        if (column.order == "descending") {
          this.orderby_workday = "desc";
        } else if (column.order == "ascending") {
          this.orderby_workday = "asc";
        }
      }
      this.userGet();
    },
    educationSelect() {
      oaApi.educationSelect({}, "get").then((res) => {
        if (res.code == 200) {
          this.educationList = res.data.education;
        }
      });
    },
    paginationChange(paginationData) {
      this.paginationData = paginationData;
      this.userGet();
    },
    delConfirm() {
    },
    delCancel() {
    },
  },
  created() {
    this.depart();
    this.userGet();
  },
  components: {
    StaffRecordDetail: StaffRecordDetail,
    StaffRecordAdd: StaffRecordAdd,
    pagination: pagination,
    StaffRecordEdit: StaffRecordEdit,
    importPublic: importPublic,
    delPopConfirm: delPopConfirm,
    popConfirm: popConfirm,
    advancedSearch: advancedSearch,
  },
  computed: {
    menuAuth() {
      return this.$store.state.menu.menuAuth;
    },
    screen() {
      return `calc(100% - 40px - 40px)`;
    },
    menu_id() {
      return this.$store.state.menu.menu_id
          ? this.$store.state.menu.menu_id
          : localStorage.getItem("menu_id");
    },
  },
};
</script>
<style lang="scss">
.staffRecord {
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: flex;
  .tableCont {
    // width: calc(100% - 250px);
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .table {
      height: calc(100% - 40px - 40px);
      width: 100%;
      .nameCont {
        display: flex;
        align-items: center;
        justify-content: start;
        .headImg {
          height: 28px;
          width: 28px;
          border-radius: 8px;
          overflow: hidden;
          margin-right: 8px;
          justify-items: flex-start;
          img{
            width: 100%;
          }
        }
        .memberName {
          line-height: 24px;
        }
      }
    }
  }
  .bulkImport {
    .bulkText {
      text-align: left;
    }
    .condition {
      width: 100%;
      li {
        text-align: left;
        line-height: 2;
      }
    }
  }
  // .el-scrollbar__wrap {
  //     overflow-x: hidden;
  // }
}

.modify_pwd_title {
  padding-bottom: 10px;
  border-bottom: 1px solid #c0c6cc;
  margin-bottom: 10px;
}
</style>
